export const handleNoDataOnResponse = (response: string | string[] = '') =>
  Array.isArray(response) ? response[0] : response;
